import { createFeature, createReducer } from '@ngrx/store';

import { overviewLocationsFeatureReducers } from './overview-locations.reducer';
import { jobLocationsOverviewInitialState } from './overview-locations.state';

export const overviewLocationsFeature = createFeature({
  name: 'jobV3OverviewLocations',
  reducer: createReducer(jobLocationsOverviewInitialState, ...overviewLocationsFeatureReducers),
});
